import { Component, Mixins } from 'vue-property-decorator';
import OrderGridsColumns from '@/components/common/order/mixins/OrderGridsColums';
import { getToday } from '@/utils/dateUtils';

@Component
export default class OrderGridsExcelDown extends Mixins(OrderGridsColumns) {
  public excelDownInfo: any = {
    fileName: 'order_list_' + getToday(),
    columns: {
      platformType: 'ORDER_LIST_GRIDS_HEADER_PLATFORM_TYPE',
      mallNo: 'ORDER_LIST_GRIDS_HEADER_MALLNO',
      orderRegisterType: 'ORDER_LIST_GRIDS_HEADER_ORDER_REGISTER_TYPE',
      reservation: 'ORDER_LIST_GRIDS_HEADER_RESERVATION_YN',
      memberGroupInfoJson: 'ORDER_LIST_GRIDS_HEADER_MEMBER_GROUP_INFO_JSON',
      recommenderId: 'ORDER_LIST_GRIDS_HEADER_RECOMMENDER_ID',
      payType: 'ORDER_LIST_GRIDS_HEADER_PAY_TYPE',
      orderNo: 'ORDER_LIST_GRIDS_HEADER_ORDER_NO',
      ordererName: 'ORDER_LIST_GRIDS_HEADER_ORDER_NAME',
      ordererContact1: 'ORDER_LIST_GRIDS_HEADER_ORDER_CONTACT1',
      holdDeliveryYmdt: 'ORDER_LIST_GRIDS_HEADER_HOLD_DELIVERY_YMT',

      holdDelivery: 'ORDER_LIST_GRIDS_HEADER_HOLD_DELIVERY_YN',
      memberNo: 'ORDER_LIST_GRIDS_HEADER_MEMBER_NO',
      shippingAreaType: 'ORDER_LIST_GRIDS_HEADER_SHIPPING_ARER_TYPE_LABEL',
      taskMessage: 'ORDER_LIST_GRIDS_HEADER_TASK_MESSAGE_YN',
      orderStatusType: 'ORDER_LIST_GRIDS_HEADER_ORDER_STATUS_TYPE',
      claimStatusType: 'ORDER_LIST_GRIDS_HEADER_CLAIM_STATUS_TYPE',
      partnerNo: 'ORDER_LIST_GRIDS_HEADER_PARTER_NO',
      hsCode: 'ORDER_LIST_GRIDS_HEADER_HS_CODE',
      mallProductNo: 'ORDER_LIST_GRIDS_HEADER_MALL_PRODUCT_NO',
      productManagementCd: 'ORDER_LIST_GRIDS_HEADER_PRODUCT_MANAGEMENT_CD',

      productName: 'ORDER_LIST_GRIDS_HEADER_PRODUCT_NAME',
      productNameEn: 'ORDER_LIST_GRIDS_HEADER_PRODUCT_NAME_EN',
      optionManagementCd: 'ORDER_LIST_GRIDS_HEADER_OPTION_MANAGEMENT_CD',
      displayOptionName: 'ORDER_LIST_GRIDS_HEADER_DISPLAY_OPTION_NAME',
      immediateDiscountedPrice: 'ORDER_LIST_GRIDS_HEADER_IMMEDIATE_DISCOUNT_PRICE',
      additionalDiscountAmt: 'ORDER_LIST_GRIDS_HEADER_ADDITIONAL_DISCOUNT_AMT',
      freeGiftDiscountAmt: '사은품 할인',
      buyPrice: 'ORDER_LIST_GRIDS_HEADER_BUY_PRICE',
      orderCnt: 'ORDER_LIST_GRIDS_HEADER_ORDER_CNT',
      totalBuyAmt: 'ORDER_LIST_GRIDS_HEADER_TOTAL_BUY_AMT',
      receiverName: 'ORDER_LIST_GRIDS_HEADER_RECEIVER_NAME',

      receiverContact1: 'ORDER_LIST_GRIDS_HEADER_RECEIVER_CONTACT1',
      receiverZipCd: 'ORDER_LIST_GRIDS_HEADER_RECEIVER_ZIP_CD',
      address: 'ORDER_LIST_GRIDS_HEADER_ADRESS',
      shippingNo: 'ORDER_LIST_GRIDS_HEADER_DELIVER_NO',
      deliveryAmtInAdvance: 'ORDER_LIST_GRIDS_HEADER_DELIVER_AMT_ADVANCE_YN',
      deliveryConditionType: 'ORDER_LIST_GRIDS_HEADER_DELIVER_CONDITION_TYPE',
      customsIdNumber: 'ORDER_LIST_GRIDS_HEADER_CUSTOMS_ID_NUMBER',
      deliveryType: 'ORDER_LIST_GRIDS_HEADER_DELIVER_TYPE',
      deliveryCompanyType: 'ORDER_LIST_GRIDS_HEADER_DELIVER_COMPANY_TYPE',
      invoiceNo: 'ORDER_LIST_GRIDS_HEADER_INVOICE_NO',

      orderYmdt: 'ORDER_LIST_GRIDS_HEADER_ORDER_YMDT',
      payYmdt: 'ORDER_LIST_GRIDS_HEADER_PAY_YMDT',
      orderAcceptYmdt: 'ORDER_LIST_GRIDS_HEADER_ORDER_ACCEPT_YMDT',
      releaseReadyYmdt: 'ORDER_LIST_GRIDS_HEADER_RELEASE_READY_YMDT',
      releaseYmdt: 'ORDER_LIST_GRIDS_HEADER_RELEASE_YMDT',
      deliveryCompleteYmdt: 'ORDER_LIST_GRIDS_HEADER_DELIVER_COMPLETE_YMDT',
      buyConfirmYmdt: 'ORDER_LIST_GRIDS_HEADER_BUY_CONFIRM_YMDT',

      ///deposit-wait
      procBtn: 'ORDER_LIST_GRIDS_HEADER_PROC_BTN',
      deliveryAmtInAdvanceYn: 'ORDER_LIST_GRIDS_HEADER_DELIVERY_AMT_INADVANCE_YN',
      adjustedAmt: 'ORDER_LIST_GRIDS_HEADER_ADJUST_AMT',
      deliveryAmt: 'ORDER_LIST_GRIDS_HEADER_ADJUST_AMT',
      remoteDeliveryAmt: 'ORDER_LIST_GRIDS_HEADER_REMOTE_DELIVERY_AMT',
      //product-prepare
      exchange: 'ORDER_LIST_GRIDS_HEADER_EXCHANGE',
      procEachBtn: 'ORDER_LIST_GRIDS_HEADER_PRCO_EACH_BTN',
      orderMemo: 'ORDER_LIST_GRIDS_HEADER_ORDER_MEMO',
      userInputTextStr: 'ORDER_LIST_GRIDS_HEADER_ORDER_USER_INPUT_TEXT_STR',
      deliveryMemo: 'ORDER_LIST_GRIDS_HEADER_DELIVERY_MEMO'
    },
    formatters: {
      platformType: (data: any): any => {
        if (data.value) {
          if(data.value === 'MOBILE_WEB') {
            return window.$t('ORDER_LIST_GRIDS_PLATFORM_TYPE_MOBILE_WEB');
          } else if(data.value === 'MOBILE_APP') {
            return window.$t('ORDER_LIST_GRIDS_PLATFORM_TYPE_MOBILE_APP');
          } else {
            return data.row.platformTypeLabel;
          }
        }
        return '-';
      },
      mallNo: (data: any): any => {
        return this.getMallName(data.value);
      },
      orderRegisterType: (data: any): any => {
        if (data.value) {
          return data.row.orderRegisterTypeLabel;
        }
        return '-';
      },
      reservation: (data: any): any => {
        if (data.value === true) {
          return 'Y';
        }
        return '-';
      },
      memberGroupInfoJson: (data: any): any => {
        if (!data.value || data.value === '' || data.value === '[]') {
          return '-';
        }
        const memberGroupInfo = JSON.parse(data.value);
        if (memberGroupInfo.length <= 0) {
          return '-';
        }
        return memberGroupInfo[0].memberGroupName;
      },
      recommenderId: (data: any): any => {
        return !data.value ? '-' : data.value;
      },
      payType: (data: any): any => {
        return data.row.payTypeLabel;
      },
      orderNo: (data: any): any => {
        return data.value + (data.row.payType === 'NAVER_PAY' ? ` (N: ${data.row.externalOrderNo})` : '');
      },
      ordererName: (data: any): any => {
        return data.value;
      },
      holdDelivery: (data: any): any => {
        if (!data.value || data.value === false) {
          return '-';
        }
        return 'Y';
      },
      memberNo: (data: any): any => {
        if (data.value === 0) {
          return '-';
        }
        return data.value;
      },
      orderStatusType: (data: any): any => {
        return data.row.orderStatusTypeLabel;
      },
      claimStatusType: (data: any): any => {
        if (!data.value) {
          return '-';
        }
        return data.row.claimStatusTypeLabel;
      },
      partnerNo: (data: any): any => {
        return data.row.partnerName;
      },
      productName: (data: any): any => {
        if (data.row.isSetOption === true) {
          return `(${window.$t('ORDER_LIST_GRIDS_PRODUCT_NAME_TAG')}) ${data.value}`;
        }
        if (data.row.isFreeGift) {
          return `(사은품) ${data.value}`
        }
        return data.value;
      },
      displayOptionName: (data: any): any => {
        return data.value;
      },
      // immediateDiscountedPrice: (data: any): any => {
      //   return this.getKorCurrency(data.value);
      // },
      // additionalDiscountAmt: (data: any): any => {
      //   return this.getKorCurrency(data.value);
      // },
      freeGiftDiscountAmt: ({ value }) => this.getKorCurrency(value),
      // buyPrice: (data: any): any => {
      //   return this.getKorCurrency(data.value);
      // },
      // orderCnt: (data: any): any => {
      //   // return this.getKorCurrency(data.value);
      //   return data.value;
      // },
      // totalBuyAmt: (data: any): any => {
      //   return this.getKorCurrency(data.value);
      // },
      deliveryAmtInAdvance: (data: any): any => {
        if (data.row.delivery === false) {
          return '-';
        }
        return data.value === false ? `${window.$t('ORDER_LIST_GRIDS_DELIVERY_AMT_TYPE_ARRIVE')}` : `${window.$t('ORDER_LIST_GRIDS_DELIVERY_AMT_TYPE_BEFORE')}`;
      },
      deliveryConditionType: (data: any): any => {
        if (!data.value) {
          return '-';
        }
        return data.row.deliveryConditionTypeLabel;
      },
      deliveryType: (data: any): any => {
        if(data.value === 'PARCEL_DELIVERY') {
          return window.$t('ORDER_ORDER_CONTENT_TOP_DELIVERY_TYPE_PARCEL_DELIVERY');
        } else if(data.value === 'DIRECT_DELIVERY') {
          return window.$t('ORDER_ORDER_CONTENT_TOP_DELIVERY_TYPE_DIRECT_DELIVERY');
        } else {
          return '-';
        }
      },
      deliveryCompanyType: (data: any): any => {
        if (!data.value) {
          return '-';
        }
        return data.value;
      },
      invoiceNo: (data: any): any => {
        return !data.value ? '-' : data.value;
      },
      payYmdt: (data: any): any => {
        if (!data.value) {
          return '-';
        }
        return data.value;
      },
      orderAcceptYmdt: (data: any): any => {
        if (!data.value) {
          return '-';
        }
        return data.value;
      },
      releaseReadyYmdt: (data: any): any => {
        if (!data.value) {
          return '-';
        }
        return data.value;
      },
      releaseYmdt: (data: any): any => {
        if (!data.value) {
          return '-';
        }
        return data.value;
      },
      deliveryCompleteYmdt: (data: any): any => {
        if (!data.value) {
          return '-';
        }
        return data.value;
      },

      buyConfirmYmdt: (data: any): any => {
        if (!data.value) {
          return '-';
        }
        return data.value;
      },
      procBtn: (): any => {
        return '';
      },
      deliveryAmtInAdvanceYn: (data: any): any => {
        return data.value === false ? `${window.$t('ORDER_LIST_GRIDS_DELIVERY_AMT_TYPE_ARRIVE')}` : `${window.$t('ORDER_LIST_GRIDS_DELIVERY_AMT_TYPE_BEFORE')}`;
      },
      // adjustedAmt: (data: any): any => {
      //   if (data.row.deliveryYn === false) {
      //     return '-';
      //   }
      //
      //   return this.getKorCurrency(data.value);
      // },
      // remoteDeliveryAmt: (data: any): any => {
      //   if (data.row.deliveryYn === false) {
      //     return '-';
      //   }
      //
      //   return this.getKorCurrency(data.value);
      // },
      //pay-done
      procEachBtn: (): any => {
        return '';
      },
      //pay-fail
      failInfo: (data: any): any => {
        if (data.row.orderStatusType == 'PAY_FAIL') {
          return data.value;
        }
        return '';
      },
      // hold-delivery
      holdDeliveryYmdt: (data: any): any => {
        if (data.value == null) {
          return '-';
        }
        return data.value;
      },
      exchange: (data: any): any => {
        if (data.value === true) {
          return 'Y';
        } else {
          return 'N';
        }
      },
      taskMessage: (data: any): any => {
        if (data.value === true) {
          return window.$t('ORDER_ORDER_CONTENT_TOP_TASK_MESSAGE_SEARCH_TYPE_PROCESSING');
        } else {
          return '';
        }
      },
      shippingAreaType: (data: any): any => {
        if (data.value === 'PARTNER_SHIPPING_AREA') {
          return window.$t('ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_PARTNER_SHIPPING_AREA');
        } else if (data.value === 'MALL_SHIPPING_AREA') {
          return window.$t('ORDER_ORDER_CONTENT_TOP_SHIPPING_AREA_TYPE_MALL_SHIPPING_AREA');
        } else {
          return '';
        }
      }
    }
  };

}
